import { TmTableColumnError } from '@/core/error/table/tmTableColumnError'

export class TmTableNoColumnsError extends TmTableColumnError {
  public name = 'TmTableNoColumnsError'
}
